module.exports = __webpack_public_path__ + "img/李淼.6045cfd3.jpg";